import { Box, Flex, IconButton, useColorModeValue } from '@chakra-ui/react';

import React, { useContext } from 'react';
import { IoMenuOutline } from 'react-icons/io5';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import { SidebarContext } from 'contexts/SidebarContext';

export default function AdminNavbar(props) {
  const { isCollapsed, setIsDrawerOpen } = useContext(SidebarContext);

  const navbarBg = useColorModeValue(
    'rgba(244, 247, 254, 0.8)',
    'rgba(11,20,55,0.8)',
  );

  return (
    <Box
      position="fixed"
      bg={navbarBg}
      backdropFilter="blur(20px)"
      borderRadius="16px"
      minH="65px"
      top="12px"
      right="12px"
      left={{ base: '12px', xl: isCollapsed ? '92px' : '312px' }}
      px="12px"
      py="8px"
      zIndex="999"
      transition="left 0.25s ease"
    >
      <Flex w="100%" align="center">
        {/* MOBILE BUTTON */}
        <IconButton
          aria-label="menu"
          icon={<IoMenuOutline />}
          variant="ghost"
          fontSize="24px"
          display={{ base: 'flex', xl: 'none' }}
          mr="10px"
          onClick={() => setIsDrawerOpen(true)}
        />

        <Box ms="auto">
          <AdminNavbarLinks {...props} />
        </Box>
      </Flex>
    </Box>
  );
}
